module.exports = __webpack_public_path__ + "media/images/wealthbar/dashboard/tada-icon-c610e848763762584d903bc60aba05c9.png";